import { getUserCountryCode } from '@internal/services/apiClient';
import { useCallback, useContext } from 'react';
import { fallbackUserCountryCode } from './User';
import { UserContext } from './UserContext';

export const useUserCountryCodeForSearch = () => {
    const { user, setUserCountryCode } = useContext(UserContext);

    const getCode = useCallback(async () => {
        let userCountryCode = user.countryCode ?? (await getUserCountryCode());
        if (userCountryCode && !user.countryCode) {
            setUserCountryCode(userCountryCode);
        }

        if (!userCountryCode) {
            userCountryCode = fallbackUserCountryCode;
        }

        return userCountryCode;
    }, [user.countryCode, setUserCountryCode]);

    return {
        getUserCountryCode: getCode,
    };
};
